// CartIcon.tsx
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../hooks/useCart.ts';
import './CartIcon.css';

const CartBadge: React.FC<{ price: number }> = React.memo(({ price }) => {
    const badgeRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (badgeRef.current) {
            if (price <= 0) {
                badgeRef.current.style.display = 'none';
            } else {
                badgeRef.current.style.display = 'flex';
                badgeRef.current.querySelector('.cart-price')!.textContent = `${price} ج.م`;
                
                // Add animation
                badgeRef.current.classList.remove('badge-pop');
                void badgeRef.current.offsetWidth; // Trigger reflow
                badgeRef.current.classList.add('badge-pop');
            }
        }
    }, [price]);

    return (
        <div className="cart-badge" ref={badgeRef}>
            <span className="cart-price">{price} ج.م</span>
        </div>
    );
});

const CartIcon: React.FC = () => {
    const navigate = useNavigate();
    const { cartStore, getTotalPrice } = useCart();
    // const [totalPrice, setTotalPrice] = useState(0); // Don't need this
    const iconRef = useRef<HTMLButtonElement>(null);
    // const prevTotalRef = useRef(totalPrice); // Don't need this

    // Calculate totalPrice directly from cartStore
    const totalPrice = getTotalPrice();

    // useEffect(() => {
    //     const newTotal = getTotalPrice();
    //     if (newTotal !== prevTotalRef.current) {
    //         setTotalPrice(newTotal);
    //         prevTotalRef.current = newTotal;

    //         if (iconRef.current && newTotal > prevTotalRef.current) {
    //             iconRef.current.classList.remove('cart-bounce');
    //             void iconRef.current.offsetWidth; // Trigger reflow
    //             iconRef.current.classList.add('cart-bounce');
    //         }
    //     }
    // }, [cartStore, getTotalPrice]); // Not needed anymore

    return (
        <button 
            ref={iconRef}
            className="cart-icon-button" 
            onClick={() => navigate('/cart')}
            aria-label="عربة التسوق"
        >
            <div className="cart-icon-wrapper">
                <svg className="cart-icon" viewBox="0 0 24 24">
                    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"/>
                </svg>
                <CartBadge price={totalPrice} />
            </div>
        </button>
    );
};

export default React.memo(CartIcon);